export default __webpack_public_path__ + "static/media/ts3.610e1112.png";